import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CountryPickerService {

  constructor(private http: HttpClient) { }

  // Function to get all countries
  public getCountries(): Observable<ICountry[]> {
    return this.http.get('/assets/data/world-countries/countries.json')
        .pipe(
            map((countries: ICountry[]) =>
                countries.map((country: ICountry) => {
                  country.name.native[0] = country.name.native[Object.keys(country.name.native)[0]];
                  return country;
                })
            )
        )
  }


}


export interface ICountry {
  name: {
    common: string;
    official: string;
    native?: {
      [key: string]: {
        official: string;
        common: string;
      };
    };
  };
  tld: [string];
  cca2: string;
  ccn3: string;
  cca3: string;
  cioc: string;
  currency: [string];
  callingCode: [number];
  capital: string;
  altSpellings: [string];
  region: string;
  subregion: string;
  languages: {
    bar: string;
  };
  translations: {
    [key: string]: {
      official: string;
      common: string;
    };
  };
  latlng: [number];
  demonym: string;
  landlocked: boolean;
  borders: [string];
  area: number;
}
